export default "__VITE_ASSET__BFLa6CXT__"